import { render, staticRenderFns } from "./NhFactoryPage.vue?vue&type=template&id=7f07cad1"
import script from "./NhFactoryPage.vue?vue&type=script&lang=js"
export * from "./NhFactoryPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports